import { render, staticRenderFns } from "./CustomAudioPlayer.vue?vue&type=template&id=2985c830"
import script from "./CustomAudioPlayer.vue?vue&type=script&lang=js"
export * from "./CustomAudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./CustomAudioPlayer.vue?vue&type=style&index=0&id=2985c830&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports